import { useContext } from "react"

import { FlowContext } from "#/shared/context"

import DepositBitcoinToken from "./DepositBitcoinToken"
import DepositTokenSelect from "./DepositTokenSelect"

export default function DepositTokenBox() {
  const { isBitcoinFlow } = useContext(FlowContext)

  return isBitcoinFlow ? <DepositBitcoinToken /> : <DepositTokenSelect />
}
